import { createActions, createReducer } from 'reduxsauce'

import ArquivosBensImoveisService from '../../servicos/ArquivosContratoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaArquivosBensImoveisInicio: [],
    buscaArquivosBensImoveisSucesso: ['arquivosBensImoveis'],
    buscaArquivosBensImoveisErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaArquivosBensImoveis = filtro => {
    return dispatch => {
        dispatch(Creators.buscaArquivosBensImoveisInicio())
        let serv = new ArquivosBensImoveisService()
        return serv
            .consultarBensImoveis(filtro)
            .then(response => dispatch(Creators.buscaArquivosBensImoveisSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaArquivosBensImoveisErro(error)))
    }
}

const buscaArquivosBensImoveisInicio = (state = INITIAL_STATE, action) => {
    return { ...state, carregando: true, erro: null }
}

const buscaArquivosBensImoveisErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaArquivosBensImoveisSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.arquivosBensImoveis, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_ARQUIVOS_BENS_IMOVEIS_INICIO]: buscaArquivosBensImoveisInicio,
    [Types.BUSCA_ARQUIVOS_BENS_IMOVEIS_ERRO]: buscaArquivosBensImoveisErro,
    [Types.BUSCA_ARQUIVOS_BENS_IMOVEIS_SUCESSO]: buscaArquivosBensImoveisSucesso,
})
